export default "__VITE_ASSET__CPxWqq7V__"